import { render, staticRenderFns } from "./MenuRecommendation.vue?vue&type=template&id=56aec490&scoped=true"
import script from "./MenuRecommendation.vue?vue&type=script&lang=js"
export * from "./MenuRecommendation.vue?vue&type=script&lang=js"
import style0 from "./MenuRecommendation.vue?vue&type=style&index=0&id=56aec490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aec490",
  null
  
)

export default component.exports